import React, { createContext, useEffect, useState } from 'react';
import { useAPI } from '../clients/quipli-service/quipli-service-client';
import { TenantContext } from './tenant-context';
// @hipaa-exclude
import LogRocket from 'logrocket';
import { Userpilot } from 'userpilot';

export interface AdminContext {
  id: number;
  name: string;
  email: string;
  permissions: string[];
  refresh: () => Promise<void>;
}

const defaultAdminContext: AdminContext = {
  id: 0,
  name: '',
  email: '',
  permissions: [],
  refresh: () => Promise.resolve(),
};

const defaultTenantContext: TenantContext = {
  contextPath: '',
  tenant: '',
  spaMode: true,
};

export const AdminContext = createContext<AdminContext>(defaultAdminContext);

export const AdminContextProvider = ({ children }: React.PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [adminContext, setAdminContext] = useState<AdminContext>(defaultAdminContext);
  const [tenantContext, setTenantContext] = useState<TenantContext>(defaultTenantContext);
  const contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf('/manager'));
  const { getAdminContext } = useAPI();

  async function refreshAdminContext() {
    const response = await getAdminContext(contextPath);
    setAdminContext({
      id: response.admin.id,
      name: response.admin.fullName,
      email: response.admin.email,
      permissions: response.permissions,
      refresh: async () => {
        await refreshAdminContext();
      },
    });
    setTenantContext({
      contextPath: response.tenantContext.serverPath || '/',
      tenant: response.tenantContext.tenant,
      spaMode: true,
      configuration: response.configuration,
    });
    return response;
  }

  const getAdminContextFromAPI = () => {
    refreshAdminContext().then((response) => {
      // @hipaa-exclude-start
      LogRocket.identify(`${response.tenantContext.tenant}-${response.admin.id}`, {
        name: response.admin.fullName,
        email: response.admin.email,
        tenant: response.tenantContext.tenant || '',
      });
      if (tenantContext.tenant === 'devops') {
        Userpilot.identify(`${response.tenantContext.tenant}-${response.admin.id}`, {
          name: response.admin.fullName,
          email: response.admin.email,
        });
      }
      // @hipaa-exclude-end
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getAdminContextFromAPI();
  }, []);

  return !isLoading ? (
    <TenantContext.Provider value={tenantContext}>
      <AdminContext.Provider value={adminContext}>{children}</AdminContext.Provider>
    </TenantContext.Provider>
  ) : null;
};
